import React from 'react';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import dynamic from 'next/dynamic';

const TopView = dynamic(() => import('./TopView'), {
  ssr: true,
});
const InfoView = dynamic(() => import('./InfoView'), {
  ssr: true,
});
const SuccessStories = dynamic(() => import('./SuccessStories'), {
  ssr: true,
});
const CamModelBottomContent = dynamic(() => import('./CamModelBottomContent'), {
  ssr: true,
});
const FreQuestion = dynamic(() => import('./freQuestions/index'), {
  ssr: true,
});
import TwoBlogSec from '../Common/TwoBlogSec';
import SectionWhat from './sectionWhat';
import SectionWho from './sectionWho';
import SectionHow from './sectionHow';
import { useAddAccountModal } from '@/context/AddAccountModalProvider';

const CamModelProtectionContent = ({ data }: { data: any }) => {
  const { openAddAccountModal } = useAddAccountModal();

  const onSubmit = () => {
    openAddAccountModal();
  };

  return (
    <div>
      <CommonBackContent>
        <TopView />
      </CommonBackContent>
      <InfoView />
      <SectionWhat />
      <CommonBackContent>
        <SectionWho />
      </CommonBackContent>

      {data.contentInfo['section-testimonial'].title && <SuccessStories data={data} />}
      <SectionHow />
      <CommonBackContent style={{ marginTop: '80px' }}>
        <TwoBlogSec
          blogList={data.blogList}
          topBlogList={data.topBlogList}
          blogTitle={data.contentInfo['section-blog']?.title}
          topBlogTitle={data.contentInfo['section-top-blog']?.title}
        />
      </CommonBackContent>
      <CommonBackContent>
        <FreQuestion data={data} />
      </CommonBackContent>
      <CommonBackContent>
        <CamModelBottomContent onClick={onSubmit} />
      </CommonBackContent>
    </div>
  );
};

export default CamModelProtectionContent;
